if (!customElements.get('build-bundle')) {
  class BuildBundle extends HTMLElement {
    constructor() {
      super();
      this.bundleItems = this.querySelector('.bundle-items');
      this.bundleToggleButtonText = this.querySelector('.bundle-toggle--btn span');
      this.bundleToggleAdded = this.querySelector('.bundle-toggle--added');
      this.bundleSelectedItems = this.querySelector('.bundle-toggle--selected');
      this.bundleCollection = this.querySelector('.bundle-temp');
      this.bundleSelect = this.querySelector('.bundle-selector');
      this.submitBtn = this.querySelector('.bundle_add-cart');

      this.calculateTotalPrice = this.calculateTotalPrice.bind(this);
      this.addToBundle = this.addToBundle.bind(this);
      this.addToBundleFromUrl = this.addToBundleFromUrl.bind(this);
      this.addBundleToCart = this.addBundleToCart.bind(this);
      this.removeFromBundle = this.removeFromBundle.bind(this);
      this.toggleBundleContainer = this.toggleBundleContainer.bind(this);
      this.selectFromList = this.selectFromList.bind(this);
      this.transformAndAddToBundle = this.transformAndAddToBundle.bind(this);
      this.calculateItems = this.calculateItems.bind(this);
      this.updateBadgeLabels = this.updateBadgeLabels.bind(this);

      this.bindEvents();
      this.init();
    }

    // ---------- Currency + formatting helpers ----------
    getActiveRate() {
      try {
        if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
          const r = Number(window.Shopify.currency.rate);
          return isNaN(r) || r <= 0 ? 1 : r;
        }
      } catch (e) {}
      return 1;
    }

    // Read a fixed price rule for N items and normalize to *shop base cents*
    getFixedRuleCentsBase(count) {
      const raw = Number(window.buildBundle.discountRule[count - 1]);
      if (isNaN(raw) || raw <= 0) return 0;
      const isCents = raw >= 1000;
      return Math.round(isCents ? raw : raw * 100);
    }

    // Convert a shop-base cents value to active currency cents
    toActiveCurrencyCents(baseCents) {
      const rate = this.getActiveRate();
      return Math.round(baseCents * rate);
    }

    formatMoney(cents, { withSymbol = true, noDecimals = false } = {}) {
  // Work out active currency code from common theme globals
  var code =
    (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
    (window.ShopifyCurrency && window.ShopifyCurrency.active) ||
    (window.Currency && window.Currency.currentCurrency) ||
    'USD';

  // Minimal symbol map
  var symbols = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    CAD: '$',
    AUD: '$',
    NZD: '$',
    JPY: '¥',
    SEK: 'kr',
    NOK: 'kr',
    DKK: 'kr',
    CHF: 'CHF'
  };
  var symbol = symbols[code] || '$';

  var value = cents / 100;
  var amountStr = noDecimals ? Math.round(value).toString() : value.toFixed(2);

  return withSymbol ? (symbol + amountStr) : amountStr;
}

    // ---------- /helpers ----------

    addEvent(parent, evt, selector, handler) {
      parent.addEventListener(evt, function (event) {
        if (event.target.matches(selector + ', ' + selector + ' *')) {
          handler.apply(event.target.closest(selector), arguments);
        }
      }, false);
    };

    transformAndAddToBundle(e) {
      e.preventDefault();
      let product = e.target.closest('[data-id]');
      let data = {
        'id': parseInt(product.getAttribute('data-id')),
        'image': product.getAttribute('data-thumb'),
        'price': parseInt(product.getAttribute('data-price')),
        'title': product.getAttribute('data-title'),
        'rating': product.getAttribute('data-rating'),
        'reviewCount': product.getAttribute('data-count'),
      };

      this.addToBundle(data);
      this.calculateItems();
    }

    addToBundle(data, replaceLastActive = false) {
  const activeItems = this.bundleItems.querySelectorAll('.bundle-item.active-item');
  const itemsAdded = activeItems.length;
  const maxCount = window.buildBundle.maxCount;

  // If we're only adding new items (from carousel/URL), respect maxCount
  if (!replaceLastActive && itemsAdded >= maxCount) {
    return;
  }

  let targetItem;

  if (replaceLastActive) {
    // Dropdown: replace the **last active** bundle item (your visible second product)
    targetItem = activeItems.length
      ? activeItems[activeItems.length - 1]
      : this.bundleItems.querySelector('.bundle-item:last-child');
  } else {
    // Normal behaviour: fill the next empty slot
    targetItem = this.bundleItems.querySelector('.bundle-item:not(.active-item)');
  }

  if (!targetItem) return;

  const nextEmptyIndex = targetItem.getAttribute('data-position');
  const addedItem_el = targetItem;
  const addedItemImage = addedItem_el.querySelector('img');

  if (addedItemImage) {
    addedItemImage.style.opacity = '0';
    addedItemImage.addEventListener(
      'load',
      () => {
        addedItemImage.style.opacity = '1';
      },
      { once: true }
    );
  }

  if (data.rating !== null) {
    addedItem_el.querySelector('.bundle__item-title').innerHTML = data.title;
    addedItem_el.querySelector('.rating__stars').style.setProperty('--rating', data.rating);
    addedItem_el.querySelector('.rating__stars').style.setProperty('--rating-max', 5);
    addedItem_el.querySelector('.rating__count').innerHTML = `(${data.reviewCount})`;
  }

  addedItem_el.classList.add('active-item');
  addedItem_el.querySelector('img').src = data.image;
  addedItem_el.querySelector('img').srcset = '';
  addedItem_el.querySelector('.bundle-item-properties-title').value =
    "#" + nextEmptyIndex + ": " + data.title;
  addedItem_el.querySelector('.bundle-item-properties').value = data.id;
  addedItem_el.dataset.price = data.price;

  // Don’t change the count when we’re just replacing an item
  const newCount = replaceLastActive ? itemsAdded : itemsAdded + 1;
  if (newCount === window.buildBundle.enableCount) {
    this.submitBtn.disabled = false;
  }

  this.calculateTotalPrice();
  this.updateBadgeLabels && this.updateBadgeLabels();

  if (this.bundleToggleAdded) {
    this.bundleToggleAdded.classList.add('show');
    setTimeout(() => {
      this.bundleToggleAdded.classList.remove('show');
    }, 2000);
  }

  this.calculateItems();
}


    addToBundleFromUrl() {
      if (typeof window.bundleUrlProducts === 'undefined' || window.bundleUrlProducts.length === 0) {
        return;
      }

      window.bundleUrlProducts.forEach(product => {
        this.addToBundle(product);
      })
    }

    async addBundleToCart() {
      let idsForCart = [];
      let data = {
        items: []
      };

      this.bundleItems.querySelectorAll('.bundle-item.active-item').forEach(function (item) {
        let id = item.querySelector(".bundle-item-properties").value;
        idsForCart.push(id);
      });

      idsForCart.forEach(function (id) {
        data.items.push({
          quantity: 1,
          id: id
        });
      });

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
        .then(async response => {
          let bundlePrice_el = document.querySelector('.bundle-footer-price');
          bundlePrice_el.classList.remove('add-underline');
          await this.refreshCart();
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          // document.querySelector(".bundle-footer-original-price").style.display = 'none';
        });
    }

    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) this.errorMsg.textContent = error;
    }

    async refreshCart() {
      const form = document.querySelector('product-form .js-product-form') ?? null;
      this.errorMsg = null;
      this.setErrorMsgState();
      this.cartDrawer = document.getElementById('cart-drawer');

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      const formData = form ? new FormData(form) : new FormData();
      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);
      formData.delete('quantity');
      formData.append('quantity', '0');

      if (!form) {
        formData.append('form_type', 'product');
        formData.append('utf8', '✓');
        formData.append('id', '19809127071801');
        formData.append('product-id', '2489588711481');
      }

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();
        const error = typeof data.description === 'string' ? data.description : data.message;

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

        if (theme.settings.afterAtc === 'page') {
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          this.updateCartIcon(data);

          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                data,
                !quickAddDrawer && theme.settings.afterAtc === 'drawer'
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refreshCart();
                }
              }
            }
          }, 700);
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === data.variant_id
        )[0];

        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === data.quantity)
                ? itemInOldCart.quantity : data.quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id
            }
          }));
        }
      } catch (error) {
        console.error(error);
        if (this.errorMsg) {
          this.dispatchEvent(new CustomEvent('on:cart:error', {
            bubbles: true,
            detail: {
              error: this.errorMsg.textContent
            }
          }));
        } else {
          console.error(error);
        }
      } finally {
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    removeFromBundle(e) {
      let next_el = e.target.nextElementSibling;
      next_el.removeAttribute('src');
      e.target.closest('.bundle-item').classList.remove('active-item');
      this.calculateTotalPrice();
      this.updateBadgeLabels();

      let itemsLeft = this.bundleItems.querySelectorAll('.active-item').length;
      if (itemsLeft < window.buildBundle.enableCount) {
        document.querySelector('.bundle_add-cart').disabled = true;
      }

      this.calculateItems();
    }

    calculateTotalPrice() {
      let items_el = this.bundleItems.querySelectorAll('.active-item');
      let bundlePrice_el = document.querySelector('.bundle-footer-price');
      let bundleOriginalPrice_el = document.querySelector('.bundle-footer-original-price');
      let totalPrice = 0;                 // base cents sum
      let totalDiscount = 0;
      let totalDiscountedPrice = 0;       // will become *active* cents before formatting
      let totalPriceText;
      let totalDiscountedPriceText;
      let discount;

      items_el.forEach((e) => {
        totalPrice += parseInt(e.getAttribute('data-price')); // base cents
      });

      totalDiscount = (!isNaN(window.buildBundle.discountRule[items_el.length - 1])) ? window.buildBundle.discountRule[items_el.length - 1] : 0;

      if (window.buildBundle.discountType === 'percentage') {
        // percentage operations in base cents, then convert totals to active currency cents
        discount = totalPrice / 100 * (totalDiscount / 100);
        totalDiscountedPrice = totalPrice - discount;

        // Convert both totals to active currency for display
        totalPrice = this.toActiveCurrencyCents(totalPrice);
        totalDiscountedPrice = this.toActiveCurrencyCents(totalDiscountedPrice);
      } else {
        // FIXED-AMOUNT MODE → show fixed bundle price (display only)
        const count = items_el.length;
        const baseFixedCents = this.getFixedRuleCentsBase(count); // base cents from rule

        if (baseFixedCents > 0) {
          totalDiscountedPrice = this.toActiveCurrencyCents(baseFixedCents);
          // Show original sum in active currency for the strikethrough
          totalPrice = this.toActiveCurrencyCents(totalPrice);
        } else {
          // No fixed rule: fall back to sum (converted)
          totalDiscountedPrice = this.toActiveCurrencyCents(totalPrice);
          totalPrice = this.toActiveCurrencyCents(totalPrice);
        }
      }

      // Format texts
      totalPriceText = this.formatMoney(totalPrice, { withSymbol: true });
      totalDiscountedPriceText = this.formatMoney(totalDiscountedPrice, { withSymbol: true });

      if (totalPrice === totalDiscountedPrice) {
        bundleOriginalPrice_el.classList.add('hidden');
      } else {
        bundleOriginalPrice_el.classList.remove('hidden');
      }

      bundleOriginalPrice_el.innerHTML = totalPriceText;
      bundlePrice_el.innerHTML = totalDiscountedPriceText;
    }

    toggleBundleContainer() {
      if (this.bundleCollection.classList.contains('hide')) {
        this.bundleCollection.classList.remove('hide');
        this.bundleToggleButtonText.textContent = "Collapse";
      } else {
        this.bundleCollection.classList.add('hide');
        this.bundleToggleButtonText.textContent = "Summary";
      }
    }

    calculateItems() {
      if (!this.bundleSelectedItems) return;
      const activeItemsLength = this.querySelectorAll('.bundle-item.active-item').length;
      const maxItems = this.bundleSelectedItems.dataset.max;
      let text = this.bundleSelectedItems.dataset.text;

      this.bundleSelectedItems.textContent = `${activeItemsLength}/${maxItems} ${text}`;
    }

    updateBadgeLabels() {
      const slots = this.bundleItems.querySelectorAll('.bundle-item');

      slots.forEach((slot, idx) => {
        const count = idx + 1;
        const ruleValue = Number(window.buildBundle.discountRule[count - 1]);

        // Ensure label exists
        let notifyEl = slot.querySelector('.bundle__item-notfy');
        if (!notifyEl) {
          notifyEl = document.createElement('div');
          notifyEl.className = 'bundle__item-notfy';
          const imgWrap = slot.querySelector('.bundle__item-img') || slot;
          imgWrap.appendChild(notifyEl);
        }

        const badge = notifyEl.querySelector('span') || notifyEl;

        if (!ruleValue || ruleValue <= 0) {
          badge.textContent = '';
          notifyEl.style.display = 'none';
          return;
        }

        // REMOVE ALL CARD LABEL TEXT COMPLETELY
badge.textContent = '';
notifyEl.style.display = 'none';
return;


        notifyEl.style.display = '';
        badge.textContent = text;
      });
    }

    selectFromList(e) {
      const bundleSelector = this.bundleSelect.querySelector('.bundle-selector-selected');
      const bundleList = this.bundleSelect.querySelector('.bundle-selector-list');
      const listItem = e.target.tagName === 'LI' ? e.target : e.target.closest('li') ? e.target.closest('li') : null;

      if (bundleList.classList.contains('hidden')) {
        bundleList.classList.remove('hidden');
      } else {
        bundleList.classList.add('hidden');
      }

      if (!listItem) {
        return;
      }

      let data = {
        'id': parseInt(listItem.dataset.id),
        'thumb': listItem.dataset.thumb,
        'image': listItem.dataset.image,
        'price': parseInt(listItem.dataset.price),
        'title': listItem.querySelector('span').textContent,
        'rating': listItem.dataset.rating,
        'reviewCount': listItem.dataset.reviewCount,
      };

      if (!bundleSelector.querySelector('img')) {
        const img = new Image();
        img.src = data.thumb;
        bundleSelector.appendChild(img);
      } else {
        bundleSelector.querySelector('img').src = data.thumb;
      }

      bundleSelector.querySelector('span').textContent = data.title;

      this.addToBundle(data, true);
    }

    bindEvents() {
      this.addEvent(document, 'click', '.add-to-cart', this.transformAndAddToBundle);
      this.addEvent(document, 'click', '.bundle__item-remove', this.removeFromBundle);
      this.addEvent(document, 'click', '.bundle_add-cart', this.addBundleToCart);
      this.addEvent(document, 'click', '.bundle-toggle--btn', this.toggleBundleContainer);
      this.addEvent(document, 'click', '.bundle-selector', this.selectFromList);
    }

    init() {
      if (window.location.pathname.includes('products/')) {
        document.querySelectorAll('.initial-product button').forEach(function (e) {
          e.click();
        });
      } else {
        window.addEventListener('scroll', function () {
          if (window.innerWidth > 798) {
            return;
          }
          let bundlesOffset = document.querySelector('#bundles-container').offsetTop + document.querySelector('#bundles-container').offsetHeight;
          let screenOffset = window.pageYOffset + window.innerHeight - 171;
          if (screenOffset >= bundlesOffset) {
            document.querySelector('.pre-build-bundle').classList.add('relative');
          } else {
            document.querySelector('.pre-build-bundle').classList.remove('relative');
          }
        });

        this.submitBtn.disabled = true;
      }

      if (window.buildBundle.initialCalculateTotalPrice) {
        document.querySelector('.bundle_add-cart').disabled = false;
        this.calculateTotalPrice();
      }

      this.addToBundleFromUrl();
      this.calculateItems();
      this.updateBadgeLabels();
    }
  }

  customElements.define('build-bundle', BuildBundle);
}
